Page goodsPage
	title = "Fahrzeuge"
	showFor = [Admin]
	needsAuth = true
	
	DatabaseTable<Good>	goods = {"goods"}
	
	show: string id = ""
		if not app.isLoggedIn then app.navigateTo loginPage; return
		html.setTitle title + app.titleSuffix
		await goods.fetchAll sort:"-updated"
		print goods.length
		refresh

	tick
		if goods.length > 0 then refresh
	
	draw
		column gap:style.gapBetweenBoxes
			for goods
				app.drawGoodBox ., isAdminPage:true
